import { __decorate, __metadata } from "tslib";
import { Component, Prop } from 'vue-property-decorator';
import BaseButton from '~/utils/base/BaseButton';
let ButtonBackToFilters = class ButtonBackToFilters extends BaseButton {
};
__decorate([
    Prop({
        default: '',
        type: String
    }),
    __metadata("design:type", String)
], ButtonBackToFilters.prototype, "color", void 0);
ButtonBackToFilters = __decorate([
    Component
], ButtonBackToFilters);
export default ButtonBackToFilters;
